// src/pages/ServicesListingPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ServiceCard } from '../components/ui/Card';
import Button from '../components/ui/Button';
import ServiceIcon from '../components/ui/ServiceIcons';

// Import all services data
import servicesData from '../data/servicesData';

const ServicesListingPage = () => {
  // Convert object to array for rendering
  const servicesArray = Object.values(servicesData);

  return (
    <div className="min-h-screen bg-white">
      {/* Header Section */}
      <div className="bg-primary text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">Our Legal Services</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Comprehensive legal solutions powered by expertise and innovation
          </p>
        </div>
      </div>

      {/* Services Grid Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl font-serif">Our Practice Areas</h2>
            <div className="w-20 h-1 bg-secondary mx-auto my-4"></div>
            <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
              Explore our diverse range of legal services tailored to meet your specific needs
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicesArray.map((service, index) => {
              // Use appropriate icon for each service
              const icon = <ServiceIcon serviceId={service.id} />;

              return (
                <ServiceCard
                  key={service.id}
                  icon={icon}
                  title={service.title}
                  description={service.description}
                  actionHref={`/services/${service.id}`}
                  style={{ animationDelay: `${index * 100}ms` }}
                  className="animate-[fadeIn_0.5s_ease-out] h-full"
                />
              );
            })}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-16 bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">Need Legal Assistance?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Our team of experienced attorneys is ready to help you navigate complex legal challenges. Contact us today for a consultation.
          </p>
          
          <Button 
            href="/contact" 
            variant="accent"
            size="lg"
            className="inline-flex items-center"
          >
            Schedule a Consultation
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>
    </div>
  );
};

export default ServicesListingPage;